var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const Svg32 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.968 21.514l-7.817-8.528c-.824-.898-.187-2.346 1.032-2.346h15.634c1.219 0 1.856 1.448 1.032 2.346l-7.817 8.528a1.4 1.4 0 01-2.064 0z",
  fill: "currentColor"
})));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0xNC45NjggMjEuNTE0Mkw3LjE1MDUxIDEyLjk4NkM2LjMyNzM4IDEyLjA4ODEgNi45NjQzOCAxMC42NCA4LjE4MjUzIDEwLjY0SDIzLjgxNzVDMjUuMDM1NiAxMC42NCAyNS42NzI2IDEyLjA4ODEgMjQuODQ5NSAxMi45ODZMMTcuMDMyIDIxLjUxNDJDMTYuNDc3MSAyMi4xMTk1IDE1LjUyMjkgMjIuMTE5NSAxNC45NjggMjEuNTE0MloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { Svg32 as ReactComponent };